// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f51a8bc4","453":"18f0a6e5","455":"2dfd7736","977":"76f42fd2"}[chunkId] + ".chunk.js";
};